import React from "react";
import { Link } from "react-router-dom";

interface HeaderItemProps {
  id: string;
  label: string;
  show: boolean;
}

const HeaderItem: React.FC<HeaderItemProps> = ({id, label, show }) => {
  return (
    <li id={id} key={label} className={`tw-py-1 tw-ps-2`}>
      <Link id={`${id}-link`} to="#">
        {show ? (
          <label id={`${id}-label`} className={`tw-text-lightslategray tw-text-xs tw-font-bold tw-font-noto-sans`}>
            {label}
          </label>
        ) : (
          <div id={`${id}-spacer`} className={`tw-py-2`}></div>
        )}
      </Link>
    </li>
  );
};

export default HeaderItem;
